module.exports = __webpack_public_path__ + "static/media/lockBlue.96d7850b.svg";